// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"568":"providers","925":"apollo"}[chunkId] || chunkId) + "." + {"301":"4e06c003","568":"a590489c","787":"606a233c","925":"53fb3643"}[chunkId] + ".chunk.js";
};